<template>
  <div class="layout-profile">
    <button class="p-link layout-profile-link" @click="onClick">
      <span class="username">میثم شایسته</span>
      <i class="pi pi-fw pi-cog"></i>
    </button>
    <transition name="layout-submenu-wrapper">
      <ul v-show="expanded">
        <li>
          <button class="p-link">
            <i class="pi pi-fw pi-user"></i><span>حساب کاربری</span>
          </button>
        </li>
        <li>
          <button @click="signOut" class="p-link">
            <i class="pi pi-fw pi-power-off"></i><span>خروج</span>
          </button>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    signOut() {
      localStorage.removeItem("jwt");
      this.$router.push({ path: `/login` });
    },
    onClick(event) {
      this.expanded = !this.expanded;
      event.preventDefault();
    },
  },
};
</script>

<style scoped>
</style>